/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./addWizard.vue?vue&type=template&id=3cb5c12b&scoped=true"
import script from "./addWizard.vue?vue&type=script&lang=js"
export * from "./addWizard.vue?vue&type=script&lang=js"
import style0 from "./addWizard.vue?vue&type=style&index=0&id=3cb5c12b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cb5c12b",
  null
  
)

export default component.exports